import {request as remoteRequest, request} from "@/utils/remoteRequest";

export function getPage(data) {
  return request({
    url: "/postInfo/searchPostInfoForPage",
    method: "post",
    data,
  });
}

export function getUnderLinePostInfoCount(data) {
  return request({
    url: "/postInfo/searchUnderLinePostInfoCount",
    method: "post",
    data,
  });
}

export function getOnlinePostInfoCount(data) {
  return request({
    url: "/postInfo/searchOnlinePostInfoCount",
    method: "post",
    data,
  });
}

export function cancelOnlinePostInfo(data) {
  return request({
    url: "/postInfo/cancelOnlinePostInfo",
    method: "post",
    data,
  });
}
//上线职位
export function onlinePostInfo(data) {
  return request({
    url: "/postInfo/setOnlinePostInfo",
    method: "post",
    data,
  });
}

export function endRecruitQuarter(data) {
  return remoteRequest({
    url: "/postInfo/endRecruitQuarter",
    method: "post",
    data,
  });
}

export function setResultByHand(data) {
  return remoteRequest({
    url: "/postSend/setResultByHand",
    method: "post",
    data,
  });
}
